import { RDDarkService } from './../dark.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rd-input-file',
  template: `<div class="rdFileInputContainer" [class.rdDark]="dark">
  <ng-container *ngIf="!files">
    <label class="rdFileInputLabel">
      <input type="file" name="rdFileInput" class="rdFileInput" [multiple]="multiple" [accept]="accept" (change)="changeValue($event)" />
      <span><i class="fas fa-upload"></i></span>
      <span>{{label}}</span>
    </label>
  </ng-container>
  <ng-container *ngIf="files">
    <span class="fileNames">
      <ng-container *ngFor="let file of files; let i = index">
        <ng-container *ngIf="i != 0">,</ng-container>
        {{file.name}}
      </ng-container>
    </span>
    <span class="fileRemover" (click)="removeFile()">
      <i class="fas fa-times"></i>
    </span>
  </ng-container>
</div>
`,
  styles: [`.rdFileInputContainer{--text-color:black;color:var(--text-color)}.rdFileInputContainer .rdFileInputLabel{cursor:pointer}.rdFileInputContainer .rdFileInputLabel span{padding:3px}.rdFileInputContainer .rdFileInputLabel .rdFileInput{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.rdFileInputContainer .fileRemover{cursor:pointer}.rdFileInputContainer.rdDark{--text-color:white}`]
})
export class RDInputFileComponent implements OnInit {

  @Input() label = 'Choose a file';
  @Input() accept = '';
  @Input() multiple = false;

  public files: FileList = null;
  public dark = false;

  @Output() fileChange: EventEmitter<any> = new EventEmitter();

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  changeValue(ev) {
    if (ev.target.files && ev.target.files.length > 0) {
      this.files = ev.target.files;
      this.fileChange.emit(this.files);
    }
  }

  removeFile() {
    this.files = null;
    this.fileChange.emit(this.files);
  }
}
